export const customer_indicators = [
  {
    text: "Total Customers",
    indicator_key: "total-customers",
    indicator_service: "crm",
    faIcon: "globe-americas",
    variant: "primary"
  },
  {
    text: "New this month",
    indicator_key: "new-customers",
    indicator_service: "crm",
    faIcon: "glass-cheers",
    variant: "primary"
  },
  {
    text: "Cancelled",
    indicator_key: "cancelled-customers",
    indicator_service: "crm",
    faIcon: "dizzy",
    variant: "danger"
  }
];

export const submission_indicators = [
  {
    text: "Total Submissions",
    indicator_key: "total-submissions",
    faIcon: "globe-americas",
    variant: "primary",
  },
  {
    text: "New this month",
    indicator_key: "new-submissions",
    faIcon: "glass-cheers",
    variant: "primary",
  },
  {
    text: "Active now",
    indicator_key: "active-submissions",
    faIcon: "concierge-bell",
    variant: "primary",
  }
];

export const sample_indicators = [
  {
    text: "Total Samples",
    indicator_key: "total-samples",
    faIcon: "globe-americas",
    variant: "primary"
  },
  {
    text: "New this month",
    indicator_key: "new-samples",
    faIcon: "glass-cheers",
    variant: "primary"
  },
  {
    text: "Active now",
    indicator_key: "active-samples",
    faIcon: "concierge-bell",
    variant: "primary"
  }
];

export const order_indicators = [
  {
    text: "Total Orders",
    indicator_key: "total-invoices",
    indicator_service: "cashier",
    faIcon: "file-alt",
    variant: "primary"
  },
  {
    text: "Paid Orders",
    indicator_key: "paid-invoices",
    indicator_service: "cashier",
    faIcon: "dollar-sign",
    variant: "success"
  },
  {
    text: "Un-Paid Orders",
    indicator_key: "unpaid-invoices",
    indicator_service: "cashier",
    faIcon: "hand-holding-usd",
    variant: "warning"
  }
];

export const project_indicators = [
  {
    text: "Total Projects",
    indicator_key: "total-projects",
    faIcon: "globe-americas",
    variant: "primary"
  },
  {
    text: "New this month",
    indicator_key: "new-projects",
    faIcon: "glass-cheers",
    variant: "primary",
  },
  {
    text: "Active now",
    indicator_key: "active-projects",
    faIcon: "concierge-bell",
    variant: "primary",
  },
  {
    text: "Un-Paid",
    indicator_key: "unpaid-projects",
    faIcon: "hand-holding-usd",
    variant: "primary",
  }
];

export const receive_indicators = [
  {
    text: "Unreceived Samples",
    indicator_key: "open-samples",
    faIcon: "globe-americas",
    variant: "primary"
  },
  {
    text: "Received Today",
    indicator_key: "received-today",
    faIcon: "glass-cheers",
    variant: "primary",
  },
  {
    text: "Stale Samples (over 15 days)",
    indicator_key: "stale-samples",
    faIcon: "dizzy",
    variant: "warning",
  }
];